import React from 'react';

const Message = (props) => {

    let className;

    const { type, message } = props;

    if (!message)
        return '';
    
    switch (type) {
        case 'info':
            className = 'infoMessage';
            break;

        case 'error':
            className = 'errorMessage';
            break;

        case 'confirm':
            className = 'confirmMessage';
            break;

        default:
            className = 'infoMessage';
        
    }

    return (
        <div className={className}>
            {message}<br/>
        </div>
    )
};

export default Message;
